// FAQs de los listados de la web: cada FAQ pertenece a una página de listado,
// identificada por departamento + ciudad + barrio (opcional) + operación.
// Los valores coinciden con los segmentos de la URL de la web.

export const WEB_URL = "https://gvre.es";

// "todas": página sin operación en la URL, la que ve quien marca venta y
// alquiler a la vez (o ninguna)
export const ALL_OPERATIONS = "todas";

export const LISTING_FAQ_OPERATIONS = [
  { value: "venta", label: "Venta" },
  { value: "alquiler", label: "Alquiler" },
  { value: ALL_OPERATIONS, label: "Venta y alquiler" },
];

// Barrios que se ofrecen para cada ciudad: los mismos que tiene ese listado
// en la web.
//   `zoneGroup`: grupo de la colección de zonas (campos `zone` y `subzone`)
//   `extraZones`: barrios de la web clasificados en otro grupo
//   `excludedZones`: zonas del grupo que la web no tiene como barrio
export const LISTING_FAQ_DEPARTMENTS = [
  {
    value: "residencial",
    label: "Residencial",
    cities: [
      { value: "madrid", label: "Madrid", zoneGroup: { zone: "Residencial" } },
      {
        value: "marbella",
        label: "Marbella",
        zoneGroup: { zone: "Costa", subzone: "Marbella" },
      },
      {
        value: "sotogrande",
        label: "Sotogrande",
        zoneGroup: { zone: "Costa", subzone: "Sotogrande" },
        // Clasificado como Marbella, pero la web lo muestra en Sotogrande
        extraZones: ["cortesin"],
      },
      {
        value: "puerto-de-santa-maria",
        label: "Puerto de Santa María",
        zoneGroup: { zone: "Costa", subzone: "Puerto de Santa María" },
      },
    ],
  },
  {
    value: "patrimonio",
    label: "Patrimonio",
    cities: [
      {
        value: "madrid",
        label: "Madrid",
        zoneGroup: { zone: "Patrimonial" },
        excludedZones: ["otros", "periferia"],
      },
    ],
  },
  {
    value: "otros-activos-y-zonas",
    label: "Otros activos & zonas",
    // Sin ciudades ni barrios: solo venta y alquiler
    cities: [],
  },
];
